import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { computed, defineComponent, ref, toRefs } from "@vue/composition-api";
export default defineComponent({
  name: "BaseSelect",
  props: {
    value: {
      type: null,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    browserAutocomplete: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const {
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    const inputRef = ref();
    const focus = () => {
      var _inputRef$value;
      inputRef == null ? void 0 : (_inputRef$value = inputRef.value) == null ? void 0 : _inputRef$value.focus();
    };
    const blur = () => {
      var _inputRef$value2;
      inputRef == null ? void 0 : (_inputRef$value2 = inputRef.value) == null ? void 0 : _inputRef$value2.blur();
    };
    const isOptionSelected = option => {
      return option.value === value.value;
    };
    const hasEmptyValue = computed(() => {
      var _value$value;
      return !!((_value$value = value.value) != null && _value$value.toString());
    });
    return {
      inputRef,
      valueModel,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      focus,
      blur,
      isOptionSelected,
      hasEmptyValue
    };
  }
});